import { useEffect, useRef, useState } from "react";

import { cn } from "@/lib/utils";

const A4_W = 1123;
const A4_H = 794;

/**
 * Renders the certificate HTML (the same document the PDF is made from) in an
 * isolated iframe, scaled to the container width.
 */
export function CertificatePreview({
  html,
  className,
}: {
  html: string;
  className?: string;
}) {
  const wrapRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(0.5);

  useEffect(() => {
    const el = wrapRef.current;
    if (!el) return;
    const measure = () => setScale(Math.min(1, el.clientWidth / A4_W));
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <div
      ref={wrapRef}
      className={cn("w-full overflow-hidden", className)}
      style={{ height: A4_H * scale }}
    >
      <iframe
        title="Certificate preview"
        srcDoc={html}
        width={A4_W}
        height={A4_H}
        style={{
          border: 0,
          transform: `scale(${scale})`,
          transformOrigin: "top left",
          background: "transparent",
        }}
      />
    </div>
  );
}
